'use client';

import dynamic from 'next/dynamic';
import type { HomepageSections, LocaleCode } from '@/types/sections';

const PostsSection = dynamic(() => import('@/components/posts-section').then((m) => m.PostsSection), {
  loading: () => null,
  ssr: false,
});

const PartnersSection = dynamic(
  () => import('@/components/partners-section').then((m) => m.PartnersSection),
  {
    loading: () => null,
    ssr: false,
  }
);

type Props = {
  postsCta?: string;
  partnersContent: HomepageSections['partners'];
  locale: LocaleCode;
  partnersOnly?: boolean;
};

export default function HomeAsyncSections({ postsCta, partnersContent, locale, partnersOnly }: Props) {
  return (
    <>
      {!partnersOnly ? (
        <PostsSection ctaLabel={postsCta} />
      ) : (
        <PartnersSection content={partnersContent} locale={locale} />
      )}
    </>
  );
}
